import { suuid } from "@zetalabs/core";
import { useMemo } from "react";

export function useStableId(deps: any[] = []) {
	const id = useMemo(() => suuid(), deps);

	return id;
}
